<div class="catalog-content">
    <form
        name="form"
        (ngSubmit)="f.form.valid && processData()"
        #f="ngForm"
        novalidate
    >
        <!-- Type -->
        <div class="form-group">
            <mat-form-field>
                <mat-select
                    disableOptionCentering
                    placeholder="Type"
                    [(ngModel)]="slectedType"
                    name="navdivedend"
                    #navdivedend="ngModel"
                    (selectionChange)="onSelectionChange($event)"
                    required
                >
                    <mat-option
                        *ngFor="let type of typeList"
                        [value]="type"
                    >
                        {{ type }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="f.submitted && navdivedend.invalid">Type is required</mat-error>
            </mat-form-field>
        </div>
        <div *ngIf="slectedType">
            <mat-radio-group name="notification-action" [(ngModel)]="truncateNeeded" class="padding-right-20">
                <mat-radio-button value=false>{{slectedType=='NAV'?'Current':'Latest'}} {{slectedType}}</mat-radio-button>
            </mat-radio-group>
            <mat-radio-group  name="notification-action" [(ngModel)]="truncateNeeded" class="padding-right-20">
                <mat-radio-button value='update'>Updated  {{slectedType}}</mat-radio-button>
            </mat-radio-group>
            <mat-radio-group name="notification-action" [(ngModel)]="truncateNeeded">
                <mat-radio-button value=true>Historic {{slectedType}}</mat-radio-button>
            </mat-radio-group>
        </div>
        <!-- Upload File -->
        <div class="form-group">
            <app-file-input
                (fileChange)="onFileChange($event)"
                [(ngModel)]="fileName"
                name="fileName"
                placeholder="Upload Excel File"
                required="true"
            >
                <button
                    type="button"
                    mat-raised-button
                    color="primary"
                >
                    Choose
                </button>
            </app-file-input>
        </div>
        <!-- BUTTON -->
        <div class="margin-top-20 text-center">
            <button
                mat-raised-button
                color="primary"
                class="mat-button-large"
                type="submit"
                [disabled]="!f.valid"
            >
                Submit
            </button>
        </div>
    </form>
    <app-catalog-nav-divident-list [data]="navDividentList"></app-catalog-nav-divident-list>
</div>
